import axios from "axios";
import instance from "./helpers/instance";

const API_URL = process.env.REACT_APP_WEB_ADMIN_URL;

const throwError401= async (clientId) => {
  return (await instance.get(`${API_URL}/api/1/clients/${clientId}/state`))?.data;
}

export { throwError401 }